import { Injectable } from '@angular/core';
import { NetworkService } from '@damofire/data-angular-commons';
import { RemoteService } from './remote.service';
import { FirebaseSavedSearchService } from '../../saved-search/firebase-saved-search.service';
import { SavedSearch } from '../../saved-search/saved-search.dto';
import { IndexedService, SAVED_SEARCH_STORE } from '@damofire/data-commons';

@Injectable()
export class SavedSearchRemoteService extends RemoteService<SavedSearch> {
  constructor(
    protected readonly idbService: IndexedService,
    protected readonly networkService: NetworkService,
    private readonly savedSearchService: FirebaseSavedSearchService,
  ) {
    super(SAVED_SEARCH_STORE, idbService, networkService);
  }

  async add(division: string, data: SavedSearch[]): Promise<void> {
    for (const savedSearch of data) {
      await this.savedSearchService.create(savedSearch);
    }
  }

  async delete(division: string, data: SavedSearch[]): Promise<void> {
    for (const savedSearch of data) {
      await this.savedSearchService.delete(division, savedSearch._id);
    }
  }

  async update(division: string, data: SavedSearch[]): Promise<void> {
    for (const savedSearch of data) {
      await this.savedSearchService.update(savedSearch);
    }
  }
}
